import { create } from 'zustand';

/**
 * Broadcast Store - Replaces reactn global broadcast state
 * Manages live streaming state and broadcast-related data
 */
const useBroadcastStore = create((set, get) => ({
  // Broadcast state
  isLive: false,

  // Actions
  setIsLive: isLive => set({ isLive }),

  resetBroadcast: () => {
    set({
      isLive: false,
    });
  },
}));

// Helper to get broadcast state outside React components
export const getBroadcastState = () => useBroadcastStore.getState();

// Helper to set isLive state outside React components
export const setGlobalIsLive = isLive => {
  useBroadcastStore.getState().setIsLive(isLive);
};

export default useBroadcastStore;
